import React from 'react';
import PropTypes from 'prop-types';
import {Animate, Box, Button, Heading, Text} from '@tenancy.nz/design-system';

function BookingSuccess({
  address = undefined,
  viewingsUrl = undefined,
  viewingDate = undefined,
  viewingTime = undefined,
}) {
  return (
    <Animate>
      <Box>
        <Heading as="h2" gutterBottom>
          Your booking has been submitted.
        </Heading>
        <Text paragraph>
          Your viewing time has been submitted. You will receive an email
          shortly with your viewing details.
        </Text>
        {address && (
          <Text sx={{mt: '25px'}} paragraph>
            Property address:
            <br />
            <strong>{address}</strong>
          </Text>
        )}
      </Box>
      {viewingDate && viewingTime && (
        <Box display="flex" gap="20px">
          <Text paragraph>
            Date: <strong>{viewingDate}</strong>
          </Text>
          <Text paragraph>
            Time: <strong>{viewingTime}</strong>
          </Text>
        </Box>
      )}
      {viewingsUrl && (
        <Box>
          <Button as="a" href={viewingsUrl} color="secondary" fill>
            Manage Your Bookings
          </Button>
        </Box>
      )}
    </Animate>
  );
}

BookingSuccess.propTypes = {
  address: PropTypes.string,
  viewingsUrl: PropTypes.string,
  viewingDate: PropTypes.string,
  viewingTime: PropTypes.string,
};

export default BookingSuccess;
